import { fetchHotel, fetchVoucherHotel } from '@/api/service'

const getPaxsHotel = (context) => {
  return fetchHotel().then((response) => {
    context.commit('PAXSHOTEL_FETCH', response)
    return response
  })
}

const getVoucherHotel = (context, paxVoucherId) => {
  if (paxVoucherId) {
    return fetchVoucherHotel(paxVoucherId).then((response) => {
      response = !_.isUndefined(response) ? response : {}
      context.commit('PAXSHOTEL_FETCH', response)
      return response
    })
  }
}

export default {
  getPaxsHotel,
  getVoucherHotel
}
